document.addEventListener('DOMContentLoaded', function() {
    // Usamos .home-swiper que es la clase que pusimos en el HTML de ACF
    const homeSwiper = document.querySelector('.home-swiper');

    if (homeSwiper) {
        new Swiper(".home-swiper", {
            loop: true,
            effect: "fade",
            fadeEffect: {
                crossFade: true
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false
            },
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev"
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            }
        });
    }
});

// Inicialización del segundo slider (Legado)
const legacySwiper = document.querySelector('.legacy-swiper');
if (legacySwiper) {
    new Swiper('.legacy-swiper', {
        slidesPerView: 1,
        spaceBetween: 30,
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        breakpoints: {
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 }
        }
    });
}